import { copy } from "shared/assets";
import { Plus } from "shared/assets/icons";
import { FancyButtonLink } from "shared/components";
import { ISelectOption } from "shared/components/Form/Fields/select/types";
import { Spacer } from "shared/layout";
import { Icon } from "shared/styles";
import { IFieldType, IFormFields, IStatus } from "shared/types";
import { TravelLegField } from "./TravelBlockPassengerForm";

const { errors } = copy;
const fields = copy.travelBlock.passenger.fields;

export const getFormFields = ({
  travelLegFields,
  setTravelLegFields,
  disableUser,
  options = [],
  addTravelLeg,
  isAddButtonDisabled,
  excludeUserIds = [],
}: {
  travelLegFields: TravelLegField[];
  setTravelLegFields: any;
  disableUser?: boolean;
  options?: ISelectOption[];
  addTravelLeg: () => void;
  isAddButtonDisabled?: boolean;
  excludeUserIds?: string[];
}): IFormFields => {
  const legFields: IFormFields = [];

  travelLegFields.forEach(({ id }) =>
    legFields.push(
      {
        name: `travelLeg.${id}`,
        label: fields.travelLeg.title,
        type: IFieldType.select,
        placeholder: fields.travelLeg.placeholder,
        options,
        onChange: (value: ISelectOption) =>
          value &&
          setTravelLegFields((fields: TravelLegField[]) =>
            fields.map((field) =>
              field.id === id ? { id, travelLegId: value.value } : field
            )
          ),
        validation: {
          required: errors.required,
        },
        note: (
          <FancyButtonLink
            data-testid={`remove_${id}`}
            status={IStatus.error}
            onClick={() =>
              setTravelLegFields((prev: TravelLegField[]) =>
                prev.filter(({ id: tId }) => tId !== id)
              )
            }
          >
            Remove
          </FancyButtonLink>
        ),
      },
      {
        name: `bookingReference.${id}`,
        label: fields.bookingReference,
        type: IFieldType.text,
      },
      {
        name: `files.${id}`,
        label: fields.ticket,
        type: IFieldType.file,
      }
    )
  );

  return [
    {
      name: "user",
      label: fields.name,
      type: IFieldType.singlePeoplePicker,
      disabled: disableUser,
      fieldLink: disableUser
        ? {
            label: "",
            onClick: () => {},
          }
        : undefined,
      validation: {
        required: errors.required,
      },
      style: {
        gridColumn: "span 3",
        mobile: {
          gridColumn: "span 1",
        },
      },
      settings: {
        includeInvitedUsers: true,
        excludeOptions: excludeUserIds,
      },
    },
    ...legFields,
    {
      name: "add",
      component: (
        <FancyButtonLink
          onClick={addTravelLeg}
          disabled={isAddButtonDisabled}
          data-testid="add_ticket"
        >
          <Spacer spaceDirection="horizontal" size="xxs" align="center">
            <Icon as={Plus} />
            <span>{fields.add}</span>
          </Spacer>
        </FancyButtonLink>
      ),
      style: {
        gridColumn: "span 3",
        mobile: {
          gridColumn: "span 1",
        },
      },
    },
  ];
};
